<script setup lang="ts">
import {Button} from "../Library";

const model = defineModel();
const anonymizationOptions = [
    {slug: "full_name", name: "Full name"},
    {slug: "initials_only", name: "Initials only"},
    {slug: "nickname", name: "Nickname"},
    {slug: "fully_anonymous", name: "Fully anonymous"},
    // {slug: "invisible", name: "Invisible"},
];
</script>
<template>
    <div class="grid grid-cols-2 gap-1">
        <Button
            v-for="option in anonymizationOptions"
            :key="option.slug"
            class="grow px-0 text-xs"
            :class="[model === option.slug ? 'bg-askr-green text-white' : 'bg-stone-200 dark:bg-stone-800']"
            @click="model = option.slug"
        >
            {{ option.name }}
        </Button>
    </div>
</template>
<style scoped></style>
